"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTitleBlock = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.colorPrimary;
}, function (p) {
  return p.theme.colorPrimaryText;
});

var SignupTitleBlock = function SignupTitleBlock(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(StyledTitleBlock, null, children);
};

var _default = SignupTitleBlock;
exports.default = _default;